import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import stringToInitials from '@/utils/filters/stringToInitials';
import initialsToColor from '@/utils/initialsToColor';

interface Props {
  user: { name: string, email?: string };
  size?: number;
  overrideFontSize?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Avatar',
  props: {
  user: null,
  size: { default: 32 },
  overrideFontSize: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props;


const style = _computed(() => (props.overrideFontSize ? ({ fontSize: `${props.size - 12}px` }) : {}));

return { __sfc: true,props, style, _computed, stringToInitials, initialsToColor }
}

})